import styles from "./Blog.styles";
import Hero from "./sections/Hero";
import Posts from "./sections/Posts";
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function Blog() {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_blog_title")} description={t("seo_blog_desc")} />
      <Hero/>
      <Posts/>
    </div>
  );
}
